// extracted by mini-css-extract-plugin
export var avatarContainer = "_75-0";
export var avatarTypingWave = "_75-i";
export var gray = "_75-f";
export var green = "_75-c";
export var icon = "_75-9";
export var image = "_75-1";
export var lg = "_75-6";
export var md = "_75-5";
export var presenceDot = "_75-b";
export var red = "_75-d";
export var sm = "_75-4";
export var status = "_75-a";
export var typingDot = "_75-h";
export var typingPill = "_75-g";
export var xl = "_75-7";
export var xs = "_75-3";
export var xxl = "_75-8";
export var xxs = "_75-2";
export var yellow = "_75-e";